export let TypeEvent = [
  {
    key: "INTERNAL",
    name: "INTERNO",
  },
  {
    key: "EXTERNAL",
    name: "EXTERNO",
  },
];

export function convertType(typeEvent) {
  const value = TypeEvent.find((type) => type.key == typeEvent);
  return value.name;
}
